import api from '../../../shared/utils/api.js'
import {
  getPropertyInteractionsRequest,
  getPropertyInteractionsSuccess,
  getPropertyInteractionsFail,
  getInterestedPropertiesRequest,
  getInterestedPropertiesSuccess,
  getInterestedPropertiesFail,
  getInterestedUserRequest,
  getInterestedUserSuccess,
  getInterestedUserFail,
  getTrendingAnalyticsRequest,
  getTrendingAnalyticsSuccess,
  getTrendingAnalyticsFail,
  getMostViewedPropertiesRequest,
  getMostViewedPropertiesSuccess,
  getMostViewedPropertiesFail,
  getSavedPropertiesRequest,
  getSavedPropertiesSuccess,
  getSavedPropertiesFail,
  getDislikedPropertiesRequest,
  getDislikedPropertiesSuccess,
  getDislikedPropertiesFail,
  getLikedPropertiesRequest,
  getLikedPropertiesSuccess,
  getLikedPropertiesFail,
  getMessageCountRequest,
  getMessageCountSuccess,
  getMessageCountFail,
  getHourlyPropertyViewsRequest,
  getHourlyPropertyViewsSuccess,
  getHourlyPropertyViewsFail,
  getPlatformRatingStatisticsRequest,
  getPlatformRatingStatisticsSuccess,
  getPlatformRatingStatisticsFail,
  getUserActivityRequest,
  getUserActivitySuccess,
  getUserActivityFail,
  // Agent Dashboard Analytics Actions
  getCallVolumeRequest,
  getCallVolumeSuccess,
  getCallVolumeFail,
  getMessageCountAnalyticsRequest,
  getMessageCountAnalyticsSuccess,
  getMessageCountAnalyticsFail,
  getSalesTrendsRequest,
  getSalesTrendsSuccess,
  getSalesTrendsFail,
  getBookingsRequest,
  getBookingsSuccess,
  getBookingsFail,
  getRatingsRequest,
  getRatingsSuccess,
  getRatingsFail,
  getCommissionReturnsRequest,
  getCommissionReturnsSuccess,
  getCommissionReturnsFail,
  getTopBrokersRequest,
  getTopBrokersSuccess,
  getTopBrokersFail,
  getTeamMembersRequest,
  getTeamMembersSuccess,
  getTeamMembersFail,
  getMostViewedPropertiesAgentRequest,
  getMostViewedPropertiesAgentSuccess,
  getMostViewedPropertiesAgentFail,
  getReviewCountsRequest,
  getReviewCountsSuccess,
  getReviewCountsFail,
} from '../../../state/redux/slices/analyticsSlice.js'

export const getInterestedProperties = () => async dispatch => {
  try {
    dispatch(getInterestedPropertiesRequest())
    const response = await api.get('/v1/interested/analytics/properties')
    dispatch(getInterestedPropertiesSuccess(response.data))
  } catch (error) {
    dispatch(getInterestedPropertiesFail(error.response?.data?.message || error.message))
  }
}

export const getInterestedUser = userId => async dispatch => {
  try {
    dispatch(getInterestedUserRequest())
    const response = await api.get(`/v1/interested/analytics/user/${userId}`)
    dispatch(getInterestedUserSuccess(response.data))
  } catch (error) {
    dispatch(getInterestedUserFail(error.response?.data?.message || error.message))
  }
}

export const getTrendingAnalytics = () => async dispatch => {
  try {
    dispatch(getTrendingAnalyticsRequest())
    const response = await api.get('/v1/interested/analytics/trending')
    dispatch(getTrendingAnalyticsSuccess(response.data))
  } catch (error) {
    dispatch(getTrendingAnalyticsFail(error.response?.data?.message || error.message))
  }
}

export const getMostViewedProperties =
  (params = {}) =>
  async dispatch => {
    try {
      dispatch(getMostViewedPropertiesRequest())

      const queryString = new URLSearchParams(params).toString()
      const url = `/v1/properties/most-viewed${queryString ? `?${queryString}` : ''}`

      const response = await api.get(url)
      dispatch(getMostViewedPropertiesSuccess(response.data))
    } catch (error) {
      dispatch(getMostViewedPropertiesFail(error.response?.data?.message || error.message))
    }
  }

export const getSavedProperties = () => async dispatch => {
  try {
    dispatch(getSavedPropertiesRequest())
    const response = await api.get('/v1/bookings/admin/saved-properties')
    dispatch(getSavedPropertiesSuccess(response.data))
  } catch (error) {
    dispatch(getSavedPropertiesFail(error.response?.data?.message || error.message))
  }
}

export const getDislikedProperties = () => async dispatch => {
  try {
    dispatch(getDislikedPropertiesRequest())
    const response = await api.get('/v1/properties/disliked')
    dispatch(getDislikedPropertiesSuccess(response.data))
  } catch (error) {
    dispatch(getDislikedPropertiesFail(error.response?.data?.message || error.message))
  }
}

export const getLikedProperties = () => async dispatch => {
  try {
    dispatch(getLikedPropertiesRequest())
    const response = await api.get('/v1/properties/liked')
    dispatch(getLikedPropertiesSuccess(response.data))
  } catch (error) {
    dispatch(getLikedPropertiesFail(error.response?.data?.message || error.message))
  }
}

export const getMessageCount = () => async dispatch => {
  try {
    dispatch(getMessageCountRequest())
    const response = await api.get('/v1/messages/count')
    dispatch(getMessageCountSuccess(response.data))
  } catch (error) {
    dispatch(getMessageCountFail(error.response?.data?.message || error.message))
  }
}

export const getHourlyPropertyViews = (params = {}) => async dispatch => {
  try {
    dispatch(getHourlyPropertyViewsRequest())
    
    const queryString = new URLSearchParams(params).toString()
    const url = `/v1/session/hourly-property-views${queryString ? `?${queryString}` : ''}`
    
    const response = await api.get(url)
    dispatch(getHourlyPropertyViewsSuccess(response.data))
  } catch (error) {
    dispatch(getHourlyPropertyViewsFail(error.response?.data?.message || error.message))
  }
}

export const getPlatformRatingStatistics = () => async dispatch => {
  try {
    dispatch(getPlatformRatingStatisticsRequest())
    const response = await api.get('/v1/reviews/ratings/statistics/platform')
    dispatch(getPlatformRatingStatisticsSuccess(response.data))
  } catch (error) {
    dispatch(getPlatformRatingStatisticsFail(error.response?.data?.message || error.message))
  }
}

export const getUserActivity = () => async dispatch => {
  try {
    dispatch(getUserActivityRequest())
    const response = await api.get('/v1/analytics/user-activity')
    dispatch(getUserActivitySuccess(response.data))
  } catch (error) {
    dispatch(getUserActivityFail(error.response?.data?.message || error.message))
  }
}

// Agent Dashboard Analytics Service Functions
export const getCallVolume = () => async dispatch => {
  try {
    dispatch(getCallVolumeRequest())
    const response = await api.get('/v1/admin/dashboard/analytics/call-volume')
    dispatch(getCallVolumeSuccess(response.data))
  } catch (error) {
    dispatch(getCallVolumeFail(error.response?.data?.message || error.message))
  }
}

export const getMessageCountAnalytics = () => async dispatch => {
  try {
    dispatch(getMessageCountAnalyticsRequest())
    const response = await api.get('/v1/admin/dashboard/analytics/message-count')
    dispatch(getMessageCountAnalyticsSuccess(response.data))
  } catch (error) {
    dispatch(getMessageCountAnalyticsFail(error.response?.data?.message || error.message))
  }
}

export const getSalesTrends = () => async dispatch => {
  try {
    dispatch(getSalesTrendsRequest())
    const response = await api.get('/v1/admin/dashboard/analytics/sales-trends')
    dispatch(getSalesTrendsSuccess(response.data))
  } catch (error) {
    dispatch(getSalesTrendsFail(error.response?.data?.message || error.message))
  }
}

export const getBookings = () => async dispatch => {
  try {
    dispatch(getBookingsRequest())
    const response = await api.get('/v1/admin/dashboard/analytics/bookings')
    dispatch(getBookingsSuccess(response.data))
  } catch (error) {
    dispatch(getBookingsFail(error.response?.data?.message || error.message))
  }
}

export const getRatings = () => async dispatch => {
  try {
    dispatch(getRatingsRequest())
    const response = await api.get('/v1/admin/dashboard/analytics/ratings')
    dispatch(getRatingsSuccess(response.data))
  } catch (error) {
    dispatch(getRatingsFail(error.response?.data?.message || error.message))
  }
}

export const getCommissionReturns = () => async dispatch => {
  try {
    dispatch(getCommissionReturnsRequest())
    const response = await api.get('/v1/admin/dashboard/analytics/commission-returns')
    dispatch(getCommissionReturnsSuccess(response.data))
  } catch (error) {
    dispatch(getCommissionReturnsFail(error.response?.data?.message || error.message))
  }
}

export const getTopBrokers = () => async dispatch => {
  try {
    dispatch(getTopBrokersRequest())
    const response = await api.get('/v1/admin/dashboard/agents/top-brokers')
    dispatch(getTopBrokersSuccess(response.data))
  } catch (error) {
    dispatch(getTopBrokersFail(error.response?.data?.message || error.message))
  }
}

export const getTeamMembers = () => async dispatch => {
  try {
    dispatch(getTeamMembersRequest())
    const response = await api.get('/v1/admin/dashboard/team/members')
    dispatch(getTeamMembersSuccess(response.data))
  } catch (error) {
    dispatch(getTeamMembersFail(error.response?.data?.message || error.message))
  }
}

export const getMostViewedPropertiesAgent = () => async dispatch => {
  try {
    dispatch(getMostViewedPropertiesAgentRequest())
    const response = await api.get('/v1/admin/dashboard/properties/most-viewed')
    dispatch(getMostViewedPropertiesAgentSuccess(response.data))
  } catch (error) {
    dispatch(getMostViewedPropertiesAgentFail(error.response?.data?.message || error.message))
  }
}

export const getReviewCounts = () => async dispatch => {
  try {
    dispatch(getReviewCountsRequest())
    const response = await api.get('/v1/admin/dashboard/reviews/counts')
    dispatch(getReviewCountsSuccess(response.data))
  } catch (error) {
    dispatch(getReviewCountsFail(error.response?.data?.message || error.message))
  }
}